
import { BrowserRouter, useLocation, Route, Routes, RouterProvider, createBrowserRouter, Navigate, Outlet } from "react-router-dom";

//import { Counter } from "./components/Counter";
//import { FetchData } from "./components/FetchData";
import { Home } from "./components/Home";

import ListingCards from "./components/ListingCards";
import { Login } from "./components/Login";

import { Layout } from './components/Layout';
import Register from './components/Register';
import ResetPassword from './components/ResetPassword';

import RequireAuth from '@auth-kit/react-router/RequireAuth'

//import { useAuth } from "./AuthContext";

/* const AppRoutes = [
  {
    index: true,
    element: <Home />
  },
  {
    path: '/counter',
    element: <Counter />
  },
  {
    path: '/fetch-data',
    element: <FetchData />
  }
];

export default AppRoutes; */

const RoutesComponent = () => {
  return (
      <BrowserRouter>
          <Layout>
              <Routes>
                  <Route path={'/'} element={<ListingCards />} />
                  <Route path={'/login'} element={<Login />} />
                  <Route path={'/profile/register'} element={<Register />} />
                  <Route path={'/profile/resetpassword'} element={<ResetPassword />} />
                  {/*<Route path={'/listing'} element={<ListingCards />} */}
                  {  /*<RequireAuth fallbackPath={'/login'}>
                            <ListingCards />
                        </RequireAuth>} 
                        />*/}
              </Routes>
          </Layout>
      </BrowserRouter>
      
  )
};
export default RoutesComponent;



const AppRoutes = [
  {
      index: true,
      element: <ListingCards />
  },
  {
      path: '/login',
      element: <Login /> //Change to Login

  }
  ,
  {
      path: '/profile/register',
      element: <Register/> //Change to Login

  }
];

/* export default AppRoutes; */

